import PropTypes from 'prop-types';
import React from 'react';
import { Label, UncontrolledTooltip } from 'reactstrap';

import Icon from '../../common/Icon';

/**
 * Shared wrapper for floating-label layout: wrapper div + label (with optional required mark and tooltip).
 * Used by FormGroupField and SelectField when floatingLabel is true.
 */
const FloatingLabelWrapper = ({
  baseClass,
  id,
  label,
  required,
  tooltip,
  children,
  labelTag: LabelTag = Label,
  labelProps = {},
}) => {
  const tooltipTargetClass = `tooltip-${id}`;

  return (
    <div className={`${baseClass}__floating-wrapper`}>
      <LabelTag
        htmlFor={id}
        className={`${baseClass}__floating-label`}
        {...labelProps}
      >
        {label}
        {required && <span className={`${baseClass}__required-mark`}>*</span>}
        {tooltip && (
          <>
            <Icon name="info" className={tooltipTargetClass} />
            <UncontrolledTooltip target={`.${tooltipTargetClass}`}>
              {tooltip}
            </UncontrolledTooltip>
          </>
        )}
      </LabelTag>
      {children}
    </div>
  );
};

FloatingLabelWrapper.propTypes = {
  baseClass: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  label: PropTypes.node.isRequired,
  required: PropTypes.bool,
  tooltip: PropTypes.string,
  children: PropTypes.node.isRequired,
  labelTag: PropTypes.elementType,
  labelProps: PropTypes.object,
};

export default FloatingLabelWrapper;
